import Vue from 'vue';
import { getSubscriptionStatus, getSampleRecord} from '../../../services/crmService/planSubscriptionService';
import { updateSubscription,updateBackMember } from '../../../services/personnelService/trialPlanService';

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
//(用於保存共享數據的)
const state = {
  customerStatus: {},
  record:[],
  // saList: {},
};

// getters
const getters = {};

// actions
const actions = {
  // 取得會員身分狀態
  async getSubscriptionStatusHandler({ commit }) {
    const data = await getSubscriptionStatus();
    commit('setData', data.data);
  },
  // 送出訂閱資料
  async updateSubscriptionHandler({}, info) {
    await updateSubscription(info);
  },
  async updateBackMemberHandler({}, info) {
    await updateBackMember(info);
  },
  // 取得會員身分狀態
  async getSampleRecordHandler({ commit }) {
    const data = await getSampleRecord();
    commit('setRecord', data.data);
  },
};

// mutations
//(用於保存修改共同數據的方法)
const mutations = {
  setData(state, data) {
    Vue.set(state, 'customerStatus', data);
  },
  setRecord(state, data) {
    Vue.set(state, 'record', data);
  },
  // setSaList(state, data) {
  //   Vue.set(state, 'saList', data.personnel);
  // },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
